import React from 'react';
import { func } from 'prop-types';
import {
  Button,
  Modal,
  ModalHeader,
  ModalSection,
  ModalFooter,
  Gutter,
  Paragraph,
  Checkbox,
  Form,
} from '@axiom/ui';

import { userClientModelShape, userModelShape } from '../../models/user';
import { patchContact } from '../../api/contact-api';
import { UserLegacyApi } from '../../api/user-legacy-api';

import { NotificationPreferencesModalSchema } from './notification-preferences-modal-schema';

export const NotificationPreferencesModal = ({ user, onClose }) => {
  const handleOnSubmit = async changedFields => {
    if (!user?.contact?.id) return;

    const payload = {
      availabilityNotificationOptOut: Object.hasOwn(
        changedFields,
        'availabilityNotification'
      )
        ? !changedFields.availabilityNotification
        : undefined,
      benchNotificationOptOut: Object.hasOwn(changedFields, 'benchNotification')
        ? !changedFields.benchNotification
        : undefined,
    };

    await patchContact(user.contact.id, payload);
    await UserLegacyApi.refreshUser();

    onClose();
  };
  return (
    <Form
      name="NOTIFICATION_FORM"
      schema={NotificationPreferencesModalSchema}
      initialValues={{
        availabilityNotification:
          !user?.contact?.availabilityNotificationOptOut,
        benchNotification: !user?.contact?.benchNotificationOptOut,
        marketingCommunications: true,
      }}
      onSubmit={handleOnSubmit}
    >
      {({ fireSubmit }) => {
        return (
          <Modal name="NOTIFICATION_PREFERENCES">
            <ModalHeader name="MODAL_HEADER" onClose={onClose}>
              Notification Preferences
            </ModalHeader>
            <ModalSection>
              <Gutter bottom="16px">
                <Paragraph>
                  Choose the bench notifications you want to receive and get
                  relevant updates sent directly to your email.
                </Paragraph>
              </Gutter>
              <Gutter vertical="8px">
                <Checkbox
                  bold
                  name="benchNotification"
                  label="Bench Updates"
                  displayValue="Let me know when there are additions or changes to talent on my bench."
                />
              </Gutter>
              <Gutter vertical="8px">
                <Checkbox
                  bold
                  name="availabilityNotification"
                  label="Availability Updates"
                  displayValue="Let me know when availability changes for talent on my bench."
                />
              </Gutter>
              <Gutter vertical="8px">
                <Checkbox
                  bold
                  disabled
                  name="marketingCommunications"
                  label="Marketing Communications"
                  displayValue={
                    <a
                      data-test="MARKETING_UNSUBSCRIBE_LINK"
                      href="https://www.axiomlaw.com/unsubscribe"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Manage your marketing email preferences on AxiomLaw.com.
                    </a>
                  }
                />
              </Gutter>
            </ModalSection>
            <ModalFooter>
              <Button name="cancel" variation="outline" onClick={onClose}>
                Cancel
              </Button>

              <Button name="submit" onClick={fireSubmit}>
                Submit
              </Button>
            </ModalFooter>
          </Modal>
        );
      }}
    </Form>
  );
};

NotificationPreferencesModal.propTypes = {
  user: userClientModelShape,
  onClose: func.isRequired,
};
